var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticStyle:{"border-color":"orangered !important"},attrs:{"value":_vm.cellId,"prefix":"$","suffix":"","readonly":"","height":"24"}})
}
var staticRenderFns = []

export { render, staticRenderFns }